import React, { useState, useEffect } from 'react';
import { Button, Card } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle, PseudoStates, Table } from '@cordata/buffet';
import { debounce } from 'lodash';

import {
  adminInstance as axios,
} from '~/utils';

const requestData = (pageSize = 20, page = 0, sorted = [], filtered = []) => {
  const filters = filtered.map(f => `${f.id}=${f.value}`);
  const sorts = `&sort=${sorted.map(s => `${s.desc ? '-' : ''}${s.id}`).join(',')}`;

  if (localStorage.getItem('org')) {
    filters.push(`org-uid=${localStorage.getItem('org')}`);
  }

  return axios
    .get(`/notification-group?${filters.join('&')}&page-size=${pageSize}&page=${page + 1}${sorts}`)
    .then(r => r.data);
};

const defaultSorted = [{
  id: 'notification-group-name',
}];

const ReminderGroups = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();
  const [pages, setPages] = useState(null);

  useEffect(() => {
    setData([]);

    if (localStorage.getItem('org')) {
      setIsLoading(true);

      requestData(undefined, undefined, defaultSorted)
        .then((r) => {
          setData(r.data);
          setPages(Math.ceil(r.total / 20));
        })
        .catch(e => setError(e))
        .then(() => setIsLoading(false));
    }
  }, [localStorage.getItem('org')]);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/admin/reminder-groups/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Reminder Group</span>
          </Button>
        }
      >
        Reminder Groups
      </PageTitle>

      <Card>
        {!error ? (
          <Table
            striped
            data={data}
            defaultSorted={defaultSorted}
            columns={[{
                id: 'notificationGroupLabel',
                Header: 'Label',
                accessor: 'attributes.notificationGroupLabel',
              }, {
                id: 'notificationGroupName',
                Header: 'Name',
                accessor: 'attributes.notificationGroupName',
              },
            ]}
            getTrProps={(state, rowInfo) => ({
              style: {
                cursor: 'pointer',
              },
              onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/reminder-groups/${rowInfo.original.id}`)),
            })}
            manual
            pages={pages}
            loading={isLoading}
            onFetchData={debounce(state => (
              localStorage.getItem('org')
                ? requestData(state.pageSize, state.page, state.sorted, state.filtered)
                  .then((r) => {
                    setData(r.data);
                    setPages(Math.ceil(r.total / state.pageSize));
                  })
                  .catch(e => setError(e))
                  .then(() => setIsLoading(false))
              : setIsLoading(false)
            ), 750)}
            filterable
          />
        ) : (
          <PseudoStates error={error} />
        )}
      </Card>
    </>
  );
};

export default ReminderGroups;
